import React from "react";
import { useIntl, defineMessages } from "react-intl";
import LoadingArea from "theme/components/molecules/LoadingArea";

const messages = defineMessages({
  defaultLoadingMessage: {
    id: "components.helpers.Loadable.defaultLoadingMessage",
    defaultMessage: "Loading...",
  },
});

export default () => {
  const intl = useIntl();
  return (
    <LoadingArea>
      {intl.formatMessage(messages.defaultLoadingMessage)}
    </LoadingArea>
  );
};
